import React from 'react';
import {
  Box,
  Typography,
  Stack,
  Tooltip,
} from '@mui/material';
import { useThemeStatics } from '../../hooks/useThemeConfig';

function IsMobileTooltip({ mdUpScreen, children, text }) {
  return mdUpScreen
    ? (<>{children}</>)
    : (<Tooltip title={text} placement="bottom-start">{children}</Tooltip>);
}

function LastItem({ mdUpScreen, config }) {
  const staticConfig = useThemeStatics();
	const { homeUrl, imageFromHomeUrl, navLastItemBackground, navBarLastItemTexts: { title, bigText, smallText } } = staticConfig;
  const backgroundUrl = staticConfig?.navLastItemBackground ? 
    ((imageFromHomeUrl ? homeUrl : '') + navLastItemBackground)
    : '';
  return !config.hidden && (
      <Box
        sx={config.container(mdUpScreen)}
      >
        {backgroundUrl !== '' && (<Box
          component="img"
          sx={config.background(mdUpScreen)}
          alt="Background call image"
          src={backgroundUrl}
        />)}
        <IsMobileTooltip mdUpScreen={mdUpScreen} text={smallText}>
          <Stack spacing={0} sx={config.stackContainer(mdUpScreen)}>
            <Typography component="span" sx={config.title(mdUpScreen)}>
              {title}
            </Typography>
            <Typography component="span" sx={config.bigText(mdUpScreen)}>
              {bigText}
            </Typography>
            {mdUpScreen && (<Typography component="span" sx={config.smallText(mdUpScreen)}>
              {smallText}
            </Typography>)}
          </Stack>
        </IsMobileTooltip>
    </Box>
  );
}

export default LastItem;